import { AppProps } from '../../../@types/AppProps';
import { Condition } from '../../../@types/Condition';
import { Valuation } from '../../../@types/Valuation';
import Accordion from '../../../Components/Accordion';
import HtmlNode from '../../../Components/Extension/HtmlNode';
import { prettyNumber } from '../../../Utils/format';
import CalculationDescription from './CalculationDescription';

const ABOUT_CALCULATION = 'about-calculation';
const ABOUT_CALCULATION_NODE = `${ABOUT_CALCULATION}-node`;

const resolveCondition = (c: Condition) => {
  switch (c) {
    case Condition.VeryGood:
      return 'veryGood';
    case Condition.Good:
      return 'good';
    case Condition.Ok:
      return 'ok';

    default:
      throw '???';
  }
};

interface ValuationResultProps {
  settings: AppProps;
  condition: Condition;
  valuation: Valuation;
}

class ValuationResult extends HtmlNode {
  private readonly props: ValuationResultProps;

  constructor(element: HTMLElement | null, props: ValuationResultProps) {
    super(element);
    this.props = props;
    element?.scrollIntoView();
    this.render();
  }

  render() {
    const {
      prediction: _prediction,
      predictionMax: _predictionMax,
      predictionMin: _predictionMin,
    } = this.props.valuation.price;
    const resolvedCondition = resolveCondition(this.props.condition);
    const reduction = this.props.settings.conditionReduction[resolvedCondition];

    const predictionMin = _predictionMin * reduction;
    const predictionMax = _predictionMax * reduction;
    const prediction = _prediction * reduction;

    this.node.innerHTML = `
      <div class="waykevaluation-stack waykevaluation-stack--3">
        <div class="waykevaluation-price-tag">
          <div class="waykevaluation-stack waykevaluation-stack--2">
            <h4 class="waykevaluation-heading waykevaluation-heading--4 waykevaluation-no-margin">Uppskattat inköpspris</h4>
          </div>
          <div class="waykevaluation-stack waykevaluation-stack--2">
            <div class="waykevaluation-stack waykevaluation-stack--1">
              <div class="waykevaluation-label">${this.props.valuation.registrationNumber}</div>
            </div>
            <div class="waykevaluation-stack waykevaluation-stack--1">
              <div class="waykevaluation-heading waykevaluation-heading--2 waykevaluation-no-margin">~ ${prettyNumber(
                prediction,
                { postfix: 'kr' }
              )}</div>
            </div>
            <div class="waykevaluation-stack waykevaluation-stack--1">
              Ett spann mellan ${prettyNumber(predictionMin, { postfix: 'kr' })} och ${prettyNumber(
      predictionMax,
      {
        postfix: 'kr',
      }
    )}.
            </div>
          </div>
        </div>
      </div>
      <div class="waykevaluation-stack waykevaluation-stack--3" id="${ABOUT_CALCULATION_NODE}"></div>
    `;

    new Accordion(this.node.querySelector<HTMLDivElement>(`#${ABOUT_CALCULATION_NODE}`), {
      id: ABOUT_CALCULATION,
      title: 'Hur har vi räknat ut det här?',
      description: CalculationDescription,
      append: true,
    });
  }
}

export default ValuationResult;
